<div class="flex flex-row mt-8">
    <a class="me-4"
       href="portal?utm_source=frontpage&utm_medium=banner&utm_campaign=applications">
        <app-cta [label]="canEditVisa ? 'SEND US YOUR VISA!' : 'APPLY NOW!'"></app-cta>
    </a>
</div>
<small class="mt-4 notation">Applications open until <b>22.05.2026</b> at 23:59 UTC +2.</small><br>
